import { Pipe, PipeTransform } from '@angular/core';
import { Municipio } from './municipio.class';

@Pipe({
    name: 'municipio_filter'
})

export class MunicipioFilterPipe implements PipeTransform {
    transform(items: Municipio[], valor: number): any {
        return items.filter(item => item.cdMicro == valor);
    }
}
